import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppSettings, AppSettingsService } from '@woolworthsnz/styleguide';
import { ExpressFulfilmentSettingsResponse } from '@woolworthsnz/trader-api';
import { distinctUntilChanged } from 'rxjs/operators';
import { FulfilmentStoreService } from '../../services';
import { NgIf, LowerCasePipe, CurrencyPipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'fulfilment-flexible-delivery',
	templateUrl: './flexible-delivery.component.html',
	styleUrls: ['./flexible-delivery.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, LowerCasePipe, CurrencyPipe],
})
export class FlexibleDeliveryComponent implements OnInit {
	expressFulfilmentSettings: ExpressFulfilmentSettingsResponse | undefined;
	appSettingServiceState$ = this.appSettingsService.state$.pipe(takeUntilDestroyed());
	allSlots$ = this.fulfilmentStoreService.select('slots').pipe(takeUntilDestroyed(), distinctUntilChanged());
	maxItemQuantityForFlexibleDeliveryOrders: number | undefined;

	constructor(
		private cdr: ChangeDetectorRef,
		private appSettingsService: AppSettingsService,
		private fulfilmentStoreService: FulfilmentStoreService
	) {}

	ngOnInit(): void {
		this.appSettingServiceState$.subscribe((appSettingsState: AppSettings) => {
			this.expressFulfilmentSettings = appSettingsState.expressFulfilmentSettings;
			this.cdr.markForCheck();
		});

		this.allSlots$.subscribe((slots) => {
			this.maxItemQuantityForFlexibleDeliveryOrders = slots?.find((slot) => slot.isFlexibleDelivery)?.itemsLimit;
			this.cdr.markForCheck();
		});
	}

	getItemsLimit(): number | undefined {
		return this.maxItemQuantityForFlexibleDeliveryOrders;
	}

	get fulfilmentMethodLabel(): string {
		return `${this.flexibleDeliveryPriceLabel}s`;
	}

	get flexibleDeliveryPriceLabel(): string {
		return '1hr window';
	}

	get deliveryMethodLabel(): string {
		return `${this.flexibleDeliveryPriceLabel} orders`;
	}

	get flexibleDeliveryFee(): number | undefined {
		return this.expressFulfilmentSettings?.flexibleDeliveryFee;
	}

	get minimumOrderCharge(): number | undefined {
		return this.expressFulfilmentSettings?.minimumOrderCharge;
	}
}
